<template>
  <div class="heading-four-container">
    <h4 class="heading-four">
      <slot />
    </h4>
  </div>
</template>

<script>
export default {
  name: 'HeadingFour'
}
</script>

<style lang="scss" scoped>
.heading-four-container {
  padding-top: 8px;
}

.heading-four {
  @extend %body-bold;
  color: $black;
  padding-left: 12px;
  border-left: 2px solid $primary;
}
</style>
